import { render, staticRenderFns } from "./ColouredValueBool.vue?vue&type=template&id=098c350e&scoped=true&"
import script from "./ColouredValueBool.vue?vue&type=script&lang=js&"
export * from "./ColouredValueBool.vue?vue&type=script&lang=js&"
import style0 from "./ColouredValueBool.vue?vue&type=style&index=0&id=098c350e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098c350e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
